import "@arco-design/web-react/es/ConfigProvider/style";
import _ConfigProvider from "@arco-design/web-react/es/ConfigProvider";

/*
 * 项目布局文件
 * 约定布局统一维护在 src/layouts 目录下。
 * 查看文档：https://eden.bytedance.net/scenario/web/pc/develop#%E6%96%B0%E5%A2%9E%E5%B8%83%E5%B1%80
 */
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import React from 'react';
import { Helmet, isBrowser } from '@ies/ace';
import SEO from '@/components/SEO';
import locale from '@arco-design/web-react/es/locale/en-US';
import { ContextProvider as ArcoMobileProvider } from '@arco-design/mobile-react';
import '@arco-design/mobile-react/esm/style';
import setRootPixel from '@arco-design/mobile-react/tools/flexible';
/** mobile 样式 */

if (isBrowser()) {
  setRootPixel();
}

const Layout = ({
  origin,
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("meta", {
  name: "viewport",
  content: "width=device-width, user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1"
}), /*#__PURE__*/React.createElement("script", {
  crossOrigin: "anonymous",
  src: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/secsdk/secsdk-lastest.umd.js"
}), /*#__PURE__*/React.createElement("script", {
  crossOrigin: "anonymous",
  src: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/webmssdk/1.0.0.24/webmssdk.js"
}), /*#__PURE__*/React.createElement("script", null, isBrowser() && `(() => {
                const LOGIN_MODE = 0x201;
                window.byted_acrawler &&
                window.byted_acrawler.init({
                  aid: ${APP_ID},
                  isSDK: false,
                  boe: false,
                  region: 'va',
                  mode: LOGIN_MODE,
                  enablePathList:  ['/api/*'],
                });

                window.secsdk && window.secsdk.csrf.setProtectedHost({
                  '${window.location.host}': {
                    'POST': [/\\/api\\/v\\d+\\/portal\\/recruitment\\/submit/]
                  }
                });
              })()`)), /*#__PURE__*/React.createElement(SEO, {
  origin: origin
}), /*#__PURE__*/React.createElement(_ConfigProvider, {
  locale: locale
}, /*#__PURE__*/React.createElement(ArcoMobileProvider, {
  prefixCls: "arco-mobile"
}, children)));

Layout.getInitialProps = context => __awaiter(void 0, void 0, void 0, function* () {
  const {
    ctx
  } = context;
  const {
    origin,
    originalUrl
  } = (ctx === null || ctx === void 0 ? void 0 : ctx.request) || {};
  return {
    origin,
    originalUrl,
    region: (ctx === null || ctx === void 0 ? void 0 : ctx.region) || ''
  };
});

export default Layout; // (() => {
//   const LOGIN_MODE = 0x201;
//   window.byted_acrawler &&
//   window.byted_acrawler.init({
//     aid: 4068,
//     isSDK: false,
//     boe: false,
//     region: 'va',
//     mode: LOGIN_MODE,
//     enablePathList:  ['/api/*'],
//   });
//   window.secsdk && window.secsdk.csrf.setProtectedHost({
//     'partner.tiktokshop.com': {
//       'POST': [/\/api\/v\d+\/portal\/recruitment\/submit/]
//     }
//   });
// })()